/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_2f11aaff{background:blue}\n"}]);
export const dummy = "dummy_2f11aaff";